<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1PtOdT/tc-custom/9781467421522.jpg?1730409343547" alt="This image is the cover for the book The Presence of the Future"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Presence of the Future
      </h1>
      <p class="bookDescription body article font2">
        <p>After surveying the debate of eschatology, Ladd discusses the promise of the kingdom, the fulfillment of the promise, and the consummation of the promise. Throughout the book he develops his thesis that the kingdom of God involves two great movements--fulfillment within history and consummation at the end of history.<br/><br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Eldon Ladd
      </h2>
      
      <p class="authorDescription body article">&#160;George Eldon Ladd (1911&ndash;1982) was professor of New Testament exegesis and theology at Fuller Theological Seminary, Pasadena, California. His numerous books include&#160;<I>The New Testament and Criticism, A Commentary on the Revelation of John</I>, and&#160;<I>Theology of the New Testament.</I>&quot;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?90701826